import { render } from "./blogWrappers.vue?vue&type=template&id=63adf723&scoped=true"
import script from "./blogWrappers.vue?vue&type=script&lang=js"
export * from "./blogWrappers.vue?vue&type=script&lang=js"

import "./blogWrappers.vue?vue&type=style&index=0&id=63adf723&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63adf723"]])

export default __exports__